import { useEffect } from "react";
import { useExperienceStore } from "@/stores/useExperienceStore";
import { preload } from "./preload.utils";
import type { useMachineProps } from "../types";

export function Preload(props: useMachineProps) {
  const{ camera, gl, scene }  = useExperienceStore((s) => s.three);

  useEffect(() => {
    if (!props.state.matches('preloading') || !camera || !gl || !scene ) return;

    // spy goes here
    (async () => {
      try
      {
        await preload(gl, scene, camera);
        if (props.actorRef.getSnapshot().matches('preloading')) {
          props.send({ type: "PRELOAD" });
        }
      }
      catch (e)
      {
        console.error("Preload failed:", e);
        if (props.actorRef.getSnapshot().matches('preloading')) {
          props.send({ type: "RETRY" });
        }
      }
    })();
  }, [props, camera, gl, scene]);

  return null;
}
